// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3657":"02a025c3","7291":"02a025c3"}[chunkId] + ".chunk.css";
};